module.exports = __webpack_public_path__ + "img/puesta-en-valor-3.f9c31263.jpg";